import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: white,
    marginVertical: indent * 0.7,
    marginHorizontal: indent * 0.7,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
  },
  titleText: {
    fontSize: 16,
    color: denim,
    flexShrink: 1,
  },
  description: {
    display: 'flex',
    textAlign: 'right',
    marginLeft: 'auto',
  },
  optaText: {
    fontSize: 14,
  },
  optaTextName: {
    fontSize: 16,
    color: denim,
  },
});
